export const BOOLEAN_CHOICES = [
  { id: true, name: 'Да' },
  { id: false, name: 'Нет' },
];
